import axiosInstance from "../../../../../api/AxiosInstance";
import { endpoints } from "../../../../../services/endpoints";
import { getFilterProductsRequest, getFilterProductsRequestError, getFilterProductsRequestSuccess } from "../../../../slices/User/Detail/Filters/GetProductSlice";

export const GetSupplierFiltersProductsApi = () => async (dispatch) => {
    try {
        dispatch(getFilterProductsRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.getSuppliersFilterProductTypes,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getFilterProductsRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getFilterProductsRequestError(_error));
            });
    } catch (error) {
    }
};
